<div class="search-bar">
  <svg-icon [name]="'search'"></svg-icon>

  <input class="search-input" id="search-input-perare" [type]="'text'" [ngModel]="value" (ngModelChange)="onValueChange($event)" [placeholder]="placeholder" (focus)="onFocus()" (blur)="onBlur()" [autofocus]="mediaQuery.isMobile" />

  <app-x-icon-button [name]="'close-large'" *ngIf="value" (click)="valueChange.emit('')"></app-x-icon-button>
  <button class="normalize-button search-button" (click)="forceSearch.emit()" *ngIf="withSearchButton">
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="8" fill="#18A0FB"/>
      <path d="M20.6951 25.1925L19.7588 24.2665L23.0099 21.0154H14.843V19.6629H23.0099L19.7588 16.4169L20.6951 15.4858L25.5484 20.3391L20.6951 25.1925Z" fill="white"/>
    </svg>
  </button>
</div>

<app-x-divider *ngIf="isActive" [type]="'medium'" [orientation]="'horizontal'" [customColor]="'rgba(0, 0, 0, 0.10)'" style="width: 100%"></app-x-divider>
